import { gql } from '@apollo/client'
import { productFragment } from 'Fragments'

const GET_EMBED = gql`
  query content($arguments: GetContent!) {
    content(arguments: $arguments) {
      _cache
      uuid
      layout {
        collections {
          preview {
            products {
              ...product
            }
          }
        }
      }
    }
  }

  ${productFragment}
`

export default GET_EMBED
